import { useUpcomingTimelinePreviewQuery } from "web_myplann/Api/NotificationCenter/useUpcomingTimelinePreviewQuery";
import {
	TimelineHorizonEnum,
	type TimelineItemResponseDTO as TimelineItem,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";

const PREVIEW_LIMIT = 2;

interface UpcomingPreview {
	items: TimelineItem[];
	hasMore: boolean;
	isLoading: boolean;
}

export const useDashboardUpcomingPreview = (): UpcomingPreview => {
	// BE applies the horizon + type filter and returns items already sorted
	// (soonest first), so no client-side filtering/sorting is needed here.
	// Deduplication against the "resolving now" section is not needed either:
	// on the BE the two sets are disjoint by construction (resolving now =
	// unsolved items dated today or earlier, upcoming = items dated after today).
	const { data, isLoading } = useUpcomingTimelinePreviewQuery({
		horizon: TimelineHorizonEnum.Month,
		type: UpcomingTimelineItemTypeFilterEnum.All,
		limit: PREVIEW_LIMIT,
	});

	return {
		items: data?.items ?? [],
		hasMore: data?.meta.hasMore ?? false,
		isLoading,
	};
};
